import React from 'react'
import * as PIXI from 'pixi.js'

const PixiDemo = (props) => {
  React.useEffect(() => {
    //Create Pixi canvas
    let renderer = new PIXI.Renderer({
      width: props.width || window.innerWidth,
      height: props.height || window.innerHeight,
      backgroundColor: 0x000000
    })
    //renderer.view.style.height = window.innerHeight + 'px'
    document.getElementById("pixi").appendChild(renderer.view)

    //Make the canvas responsive
    const resizeToFit = () => {
      renderer.resize(window.innerWidth, window.innerHeight)
      //renderer.view.style.height = window.innerHeight + 'px'
    }
    window.addEventListener("resize", resizeToFit)

    //Render scene
    let ticker = new PIXI.Ticker()
    ticker.add(() => {
      draw(renderer)
    }, PIXI.UPDATE_PRIORITY.LOW)
    ticker.start()

    return (
      () => {
        window.removeEventListener("resize", resizeToFit)
      }
    )
  }, [])

  function draw(renderer) {
    let scene = new PIXI.Container()

    let container = new PIXI.Container()
    let bg = new PIXI.Sprite(props.images[0].texture)
    let scale = window.innerHeight / bg.height
    bg.scale.set(scale, scale)
    bg.alpha = props.alpha || 1
    bg.x = window.innerWidth / 2 - bg.width / 2
    bg.y = window.innerHeight / 2 - bg.height / 2
    container.addChild(bg)

    for (let i = 1; i < props.images.length; i++) {
      let entity = new PIXI.Sprite(props.images[i].texture)
      entity.scale.set(0.7, 0.7)
      entity.x = window.innerWidth * (props.entityX || 0.5) - entity.width / 2
      entity.y = window.innerHeight * (props.entityY || 0.5) - entity.height / 2
      container.addChild(entity)
    }

    scene.addChild(container)
    renderer.render(scene)
  }

  return (
    <div
      id="pixi"
      style={{
        position: "absolute",
        width: "100%",
        height: "100%",
        backgroundColor: "Black",
        overflow: "hidden"
      }}
    />
  )
}

export default PixiDemo
